const initializeFormValidation = () => {
  const form = document.querySelector(".profile-edit-form")
  if (!form) return

  const requiredFields = form.querySelectorAll(".required-field")
  const submitButton = form.querySelector(".submit-button")
  const emailInput = form.querySelector("input[type='email']")
  const phoneInput = form.querySelector("input#user_phone")

  const addValidationMessage = (input, message) => {
    const existingMessage = input.parentElement.querySelector(".validation-message")
    if (!existingMessage) {
      const messageElement = document.createElement("div")
      messageElement.className = "validation-message text-danger small mt-1"
      messageElement.style.display = "none"
      messageElement.textContent = message
      input.parentElement.appendChild(messageElement)
      return messageElement
    }
    return existingMessage
  }

  const emailMessage = addValidationMessage(emailInput, "Please enter a valid email address")
  const phoneMessage = addValidationMessage(phoneInput, "Please enter a valid phone number")

  const isValidEmail = email => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const isValidPhone = phone => {
    return /^\d+$/.test(phone.replace(/[-\s()]/g, ""))
  }

  const validateForm = () => {
    let isValid = true

    requiredFields.forEach(field => {
      const value = field.tagName.toLowerCase() === "select" ? field.options[field.selectedIndex]?.value : field.value

      if (!value || !value.trim()) {
        isValid = false
      }
    })

    if (emailInput.value.trim()) {
      const validEmail = isValidEmail(emailInput.value)
      emailMessage.style.display = validEmail ? "none" : "block"
      if (!validEmail) isValid = false
    }

    if (phoneInput.value.trim()) {
      const validPhone = isValidPhone(phoneInput.value)
      phoneMessage.style.display = validPhone ? "none" : "block"
      if (!validPhone) isValid = false
    }

    submitButton.disabled = !isValid
  }

  validateForm()

  requiredFields.forEach(field => {
    const events = ["input", "change", "blur"]
    events.forEach(eventType => {
      field.addEventListener(eventType, validateForm)
    })
  })
  form.addEventListener("submit", e => {
    validateForm()
    if (submitButton.disabled) {
      e.preventDefault()
    }
  })
}

document.addEventListener("turbolinks:load", initializeFormValidation)
document.addEventListener("DOMContentLoaded", initializeFormValidation)
